window._abyss = window._abyss || {};
window._abyss.template = (function (template, $) {
    'use strict';

    var initEditorTitleFolder = function () {
        $('.js-editorTitleFolder').on('click', function () {
            var SPEED = 300;
            var $this = $(this);
            var $contentBox = $this.next('.js-editorContentFolder');

            if ($this.hasClass('active')) {
                $this.removeClass('active');
                $contentBox.slideUp(SPEED);
            } else {
                $this.addClass('active');
                $contentBox.slideDown(SPEED);
            }
        });

        $('.js-editorTitleFolder').each(function (idx, itm) {
            var $itm = $(itm);
            var $content;
            if (!$itm.hasClass('active')) {
                $content = $itm.nextAll('.js-editorContentFolder');
                $content.hide();
            }
        });
    };

    var templateInit = function () {
        initEditorTitleFolder();
    };

    templateInit();

    return template;
})(window._abyss.template || {}, jQuery);
